import { createContext } from "react";

const DirtyCheckContext = createContext();

export default DirtyCheckContext;